import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Spinner, Alert } from "react-bootstrap";
import { entityService, Entity } from "../services/entityService";
import { useEntity } from "../contexts/EntityContext";
import { useAuth } from "../contexts/AuthContext";
import "./EntitySelectionComponent.css";

const EntitySelectionComponent: React.FC = () => {
    const { currentEntity, setCurrentEntity, clearCurrentEntity } = useEntity();
    const { user } = useAuth();
    const [entities, setEntities] = useState<Entity[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        clearCurrentEntity();

        const fetchEntities = async () => {
            try {
                setLoading(true);
                setError(null);
                const data = await entityService.getUserEntities();
                setEntities(data);
            } catch (err) {
                setError('Erro ao carregar entidades');
                console.error('Error fetching entities:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchEntities();
    }, []);

    const handleEntitySelect = async (entity: Entity) => {
        try {
            await setCurrentEntity(entity);
        } catch (err) {
            setError('Erro ao selecionar entidade');
            console.error('Error selecting entity:', err);
        }
    };

    if (loading) {
        return (
            <Container className="mt-4 text-center">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Carregando...</span>
                </Spinner>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="mt-4">
                <Alert variant="danger" onClose={() => setError(null)} dismissible>
                    {error}
                </Alert>
                {!currentEntity && entities.length > 0 && (
                    <Row className="g-4 mt-3">
                        {entities.map((entity) => (
                            <Col md={6} key={entity.entidade_id}>
                                <Card
                                    className="entity-card"
                                    onClick={() => handleEntitySelect(entity)}
                                >
                                    <Card.Body>
                                        <Card.Title>{entity.nome}</Card.Title>
                                        <Card.Subtitle className="mb-2 text-muted">
                                            {entity.descricao}
                                        </Card.Subtitle>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}
            </Container>
        );
    }

    if (!currentEntity) {
        return (
            <Container className="mt-4">
                <div className="mb-4">
                    <h4>Olá, {user?.name}</h4>
                    <h4>Selecione uma Entidade</h4>
                </div>

                <div className="mb-5">
                    {entities.length === 0 ? (
                        <div className="text-center py-5">
                            <div className="mb-3">
                                <i className="fas fa-building fa-3x text-muted"></i>
                            </div>
                            <h5 className="text-muted mb-3">Nenhuma Entidade Disponível</h5>
                            <p className="text-muted mb-0">
                                Você não tem acesso a nenhuma entidade no momento.
                            </p>
                            <p className="text-muted">
                                Entre em contato com o administrador do sistema para solicitar acesso.
                            </p>
                        </div>
                    ) : (
                        <>
                            <h5 className="mb-3">Entidades Disponíveis</h5>
                            <Row className="g-4">
                                {entities.map((entity) => (
                                    <Col md={6} key={entity.entidade_id}>
                                        <Card
                                            className="entity-card"
                                            onClick={() => handleEntitySelect(entity)}
                                        >
                                            <Card.Body>
                                                <Card.Title className="text-dark">{entity.nome}</Card.Title>
                                                <Card.Subtitle className="mb-2 text-muted">
                                                    {entity.descricao}
                                                </Card.Subtitle>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </>
                    )}
                </div>
            </Container>
        );
    }

    return (
        <Container className="mt-4 text-center">
            <div className="py-5">
                <h4>Entidade selecionada: {currentEntity.nome}</h4>
                <p className="text-muted">Aguarde, carregando seleção de ano...</p>
            </div>
        </Container>
    );
};

export default EntitySelectionComponent;